<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  color: 'blue' | 'green' | 'yellow'
}>()

const COLORS = {
  blue: { background: 'var(--color-bg-surface-blue)', color: 'var(--blue-500)' },
  green: { background: 'var(--color-bg-surface-green)', color: 'var(--green-500)' },
  yellow: { background: 'var(--color-bg-surface-yellow)', color: 'var(--color-text-yellow)' },
} as const

const pillStyle = computed(() => COLORS[props.color])
</script>

<template>
  <span
    class="color-pill inline-flex items-center rounded-full px-3 py-1 font-semibold leading-none whitespace-nowrap"
    :style="pillStyle"
  >
    <slot/>
  </span>
</template>

<style scoped lang="scss">
.color-pill {
  font-size: 0.8125rem;
}
</style>
